module.exports = __webpack_public_path__ + "static/027-d9548b604e5a44a1613bd5b7984aaac9.jpg";